__turbopack_context__.v({
  "Avatar": "ConnectionInfoPopover-module-scss-module__OgVj8G__Avatar",
  "CardContent": "ConnectionInfoPopover-module-scss-module__OgVj8G__CardContent",
  "HeaderContainer": "ConnectionInfoPopover-module-scss-module__OgVj8G__HeaderContainer",
  "HeaderTextContainer": "ConnectionInfoPopover-module-scss-module__OgVj8G__HeaderTextContainer",
  "InfoContainer": "ConnectionInfoPopover-module-scss-module__OgVj8G__InfoContainer",
  "InfoRow": "ConnectionInfoPopover-module-scss-module__OgVj8G__InfoRow",
  "MainCard": "ConnectionInfoPopover-module-scss-module__OgVj8G__MainCard",
});
